<template>
  <div>
    <Experiences :profile="profile" />
  </div>
</template>

<script>
// Components
import Experiences from '@/components/candidate/profile/edit/experience/Experiences'

// Helpers
import { mapGetters } from 'vuex'

export default {
  components: { Experiences },

  props: { profile: { type: Object, required: true } },
}
</script>
